import { motion } from "framer-motion";

const HERO_IMG =
    "https://static.wixstatic.com/media/d92b8c_998961dee7d9400ea5b569bcb1952a35~mv2.jpg/v1/fill/w_2400,h_1300,al_c,q_85,enc_auto/lopezhill_hero.jpg";

export default function Hero() {
    return (
        <section
            id="top"
            className="relative min-h-screen w-full overflow-hidden flex items-end"
            data-testid="hero-section"
        >
            <div
                className="absolute inset-0 bg-cover bg-center scale-105"
                style={{ backgroundImage: `url(${HERO_IMG})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/70" />

            <div className="relative z-10 container-px pb-24 sm:pb-32 pt-40 w-full">
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-xs uppercase tracking-[0.28em] font-medium text-white/80"
                    data-testid="hero-overline"
                >
                    Spicewood, Texas · Hill Country
                </motion.p>

                <motion.h1
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.15 }}
                    className="mt-6 text-white font-serif font-light tracking-tighter leading-[1.02] text-5xl sm:text-7xl lg:text-[7.5rem] max-w-5xl"
                    data-testid="hero-title"
                >
                    A masterpiece <br className="hidden sm:block" />
                    for your <em className="italic text-[hsl(var(--accent))]">masterpiece.</em>
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="mt-8 max-w-xl text-white/85 text-lg font-light leading-relaxed"
                    data-testid="hero-subtitle"
                >
                    A hacienda of mosaics, art and Texas Hill Country light — thirty minutes
                    west of Austin. Crafted for weddings that feel utterly your own.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6 }}
                    className="mt-12 flex flex-wrap gap-4"
                >
                    <a
                        href="#booking"
                        className="px-8 py-4 bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))] hover:bg-[hsl(43_70%_45%)] transition-all duration-300 text-sm tracking-[0.2em] uppercase"
                        data-testid="hero-book-btn"
                    >
                        Book Your Wedding
                    </a>
                    <a
                        href="#experience"
                        className="px-8 py-4 border border-white/60 text-white hover:bg-white hover:text-[hsl(var(--foreground))] transition-all duration-300 text-sm tracking-[0.2em] uppercase"
                        data-testid="hero-explore-btn"
                    >
                        Discover the Estate
                    </a>
                </motion.div>
            </div>

            <div className="absolute bottom-6 right-6 sm:right-12 z-10 hidden sm:flex items-center gap-3 text-white/70 text-xs tracking-widest uppercase">
                <span className="h-px w-12 bg-white/40" />
                Scroll
            </div>
        </section>
    );
}
